module.exports = __webpack_public_path__ + "static/img/mode-bg.c424d91f.png";